export default "__VITE_ASSET__t$9yQBuR__"